import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import ImageComponent from '../../common/Image';
import { getTimeBasedGreeting } from '../../../utils/functions';
import { logout } from '../../../slices/auth/authSlice';

const Headers = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { userData } = useSelector((state) => state.auth);
    const { dashboardDetails, notifications } = useSelector((state) => state.dashboard);
    const userName = userData?.response_data?.data?.userName || '';
    const emailID = userData?.response_data?.data?.emailID || '';

    // Calculate total count from dashboard data
    const responseData = dashboardDetails?.response_data || [];
    const totalCount = userData?.response_data?.dealer_data?.length
    const href = "#"

    const handleNotification = () => {
        navigate('/notification')
    }

    const handleLogout = () => {
        navigate('/login');
        dispatch(logout());
    };

    const handleEmiCalculator = (e) => {
        navigate('/emicalculator')
    }

    const handleDealerList = () => {
        navigate('/dealerList')
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            navigate('/notification');
        }
    };

    return (
        <div className="position-relative">
            <header className="sticky-top ">
                <div className="container-fluid topNav-dashcount">
                    <div className="web-header">
                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                            <div className="d-flex align-items-center tablet-content">
                                <a href="/dashboard">
                                    <ImageComponent
                                        fileName="cholacd.svg"
                                        alt='chola'
                                        style={{ height: "40px" }}
                                        className="img-fluid" />
                                </a>
                                <h6 className="Pname">CD</h6>
                            </div>
                            <div className="d-flex align-items-center gap-4">
                                <div className="web-search">
                                    <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative">
                                        <input type="search" className="form-control" placeholder="Search by Application ID" aria-label="Search" />
                                        <div className="has-i">
                                            <span className="icon-searchnormal text-white"></span>
                                        </div>
                                    </form>
                                </div>
                                <div className="dropdown d-flex align-items-center text-white gap-3">
                                    <div id="#notification">
                                        <div className="dropdown lh-1" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="icon-notification01 fs-2"></span>
                                            <span className="noti-count">12</span>
                                        </div>
                                        <ul className="noti dropdown-menu dropdown-menu-end">
                                            <li className="noti-header">
                                                <h5>Notifications</h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </li>
                                            <li className="item">
                                                <div className="d-flex align-items-start gap-3">
                                                    <i className="material-symbols-outlined">
                                                        notifications
                                                    </i>
                                                    <div>
                                                        <h6>Problem validating session</h6>
                                                        <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                        <p className="mb-0">
                                                            There was a problem validating your session. It
                                                            may have expired. Please try reloading this page.
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="item">
                                                <div className="d-flex align-items-start gap-3">
                                                    <i className="material-symbols-outlined">
                                                        notifications
                                                    </i>
                                                    <div>
                                                        <h6>Document Check List</h6>
                                                        <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                        <p className="mb-0">
                                                            The specific error is: SessionToken NotFound
                                                            Exception. This also may happen if your license
                                                            has expired.
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div id="#userProfile" className='d-none'>
                                        <a
                                            href={href}
                                            className="d-flex align-items-center link-light text-decoration-none dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <div className="dp rounded-circle">RK</div>
                                            <div className="name">
                                                Hi, Ravi Kumar<br />
                                                Stores: <span className="text-white">Sree Rajee</span>
                                            </div>
                                        </a>
                                        <ul className="dropdown-menu text-small">
                                            <li>
                                                <a className="dropdown-item" href={href}>New project...</a>
                                            </li>
                                            <li><a className="dropdown-item" href={href}>Settings</a></li>
                                            <li><a className="dropdown-item" href={href}>Profile</a></li>
                                            <li>
                                                <hr className="dropdown-divider" />
                                            </li>
                                            <li><a className="dropdown-item" href={href}>Sign out</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mob-header">
                        <div
                            className="d-flex flex-wrap align-items-center justify-content-between position-relative"
                        >
                            <div className="d-flex align-items-center">
                                <a href="/dashboard">
                                    <ImageComponent
                                        fileName="cholacd.svg"
                                        alt='chola'
                                        style={{ height: "50px" }}
                                        className="img-fluid" />
                                </a>
                            </div>
                            <div className="dropdown d-flex align-items-center text-white gap-3">
                                <div onKeyDown={handleKeyDown} onClick={handleNotification} className="notification-mob">
                                    <div
                                        className="dropdown lh-1"
                                    >
                                        <button className="btn border-0 bg-tranparent p-0 text-white icon-notification01 fs-2"></button>
                                        {notifications && notifications.length > 0 && <span className="noti-count">{notifications.length}</span>}
                                    </div>
                                    <ul className="noti dropdown-menu dropdown-menu-end">
                                        <li className="noti-header">
                                            <h5>Notifications</h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            ></button>
                                        </li>
                                        <li className="item">
                                            <div className="d-flex align-items-start gap-3">
                                                <i className="material-symbols-outlined"> notifications </i>
                                                <div>
                                                    <h6>Problem validating session</h6>
                                                    <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                    <p className="mb-0">
                                                        There was a problem validating your session. It may
                                                        have expired. Please try reloading this page.
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="item">
                                            <div className="d-flex align-items-start gap-3">
                                                <i className="material-symbols-outlined"> notifications </i>
                                                <div>
                                                    <h6>Document Check List</h6>
                                                    <dt>Today, 24-10-2024 | 09:37 AM</dt>
                                                    <p className="mb-0">
                                                        The specific error is: SessionToken NotFound
                                                        Exception. This also may happen if your license has
                                                        expired.
                                                    </p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-2 d-flex align-items-center">
                                    <a
                                        data-bs-toggle="offcanvas"
                                        href="#offcanvasExample"
                                        aria-controls="offcanvasExample"
                                        className="side-toggle"
                                    >
                                        <span className="icon-Essetional-menu01 fs-1"></span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="mt-3">
                                <div className="name">
                                    Hi, {userName}
                                </div>
                                <div className="wish">{getTimeBasedGreeting()}!</div>
                            </div>
                        </div>

                        <div className="pt-3" onClick={() => handleDealerList()}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleDealerList();
                                }
                            }}
                            tabIndex={0}
                            role="button"
                            aria-label="Show document options">
                            <div className="d-flex justify-content-between class-created">
                                <p className="dark-blue mb-0">Total Stores</p>
                                <h3 className="mb-0">{totalCount}</h3>
                            </div>
                        </div>

                        <div
                            className="offcanvas offcanvas-end off-side-canvas"
                            tabIndex="-1"
                            id="offcanvasExample"
                            aria-labelledby="offcanvasExampleLabel"
                        >
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasLabel">
                                    <ImageComponent
                                        fileName="CholaLogo.svg"
                                        alt='CholaLogo' />
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="offcanvas-body">
                                <div>
                                    <ul className="nav nav-pills flex-column mb-auto">
                                        <li className="manage-menu d-flex align-items-center">
                                            <span
                                                className="icon-Contentdocument-previous fs-6 dark-blue"
                                            ></span>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const today = new Date();
                                                    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

                                                    const params = {
                                                        from_dt: oneMonthAgo.toISOString().slice(0, 10) + ' 00:00:00',
                                                        to_dt: today.toISOString().slice(0, 10) + ' 23:59:59',
                                                        status: 'all',
                                                        dealer_code: 'all'
                                                    };

                                                    navigate('/application', { state: params });
                                                }}
                                                className="nav-link menu-link dark-blue"
                                                aria-current="page"
                                            >
                                                Applications
                                            </button>
                                        </li>
                                        <li className="manage-menu d-flex align-items-center">
                                            <span className="icon-Bankcalculator fs-6 dark-blue"></span>
                                            <a href={href} className="nav-link link-body-emphasis dark-blue" onClick={(e) => { e.preventDefault(); handleEmiCalculator(); }}>
                                                EMI Calculator
                                            </a>
                                        </li>
                                        <li className="manage-menu d-flex align-items-center">
                                            <span
                                                className="icon-Contentdocument-sketch fs-6 dark-blue"
                                            ></span>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const today = new Date();
                                                    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

                                                    const params = {
                                                        from_dt: oneMonthAgo.toISOString().slice(0, 10) + ' 00:00:00',
                                                        to_dt: today.toISOString().slice(0, 10) + ' 23:59:59',
                                                        status: 'all',
                                                        dealer_code: 'all'
                                                    };

                                                    navigate('/leads', { state: params });
                                                }}
                                                className="nav-link menu-link dark-blue"
                                                aria-current="page"
                                            >
                                                Leads
                                            </button>
                                        </li>
                                        <li className="manage-menu d-flex align-items-center">
                                            <span
                                                className="icon-Contentdocument-sketch fs-6 dark-blue"
                                            ></span>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const today = new Date();
                                                    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

                                                    const params = {
                                                        from_dt: oneMonthAgo.toISOString().slice(0, 10) + ' 00:00:00',
                                                        to_dt: today.toISOString().slice(0, 10) + ' 23:59:59',
                                                        status: 'all',
                                                        dealer_code: 'all'
                                                    };

                                                    navigate('/claims', { state: params });
                                                }}
                                                className="nav-link menu-link dark-blue"
                                                aria-current="page"
                                            >
                                                Insurance Claim
                                            </button>
                                        </li>
                                        <li className="manage-menu d-flex align-items-center">
                                            <span
                                                className="icon-Contentnote-add fs-6 dark-blue"
                                            ></span>
                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    const today = new Date();
                                                    const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

                                                    const params = {
                                                        from_dt: oneMonthAgo.toISOString().slice(0, 10) + ' 00:00:00',
                                                        to_dt: today.toISOString().slice(0, 10) + ' 23:59:59',
                                                        status: 'all',
                                                        dealer_code: 'all'
                                                    };

                                                    navigate('/faq', { state: params });
                                                }}
                                                className="nav-link menu-link dark-blue"
                                                aria-current="page"
                                            >
                                                FAQ
                                            </button>
                                        </li>
                                        <li className="manage-menu d-none d-flex align-items-center">
                                            <span className="icon-Bankcalculator fs-6 dark-blue"></span>
                                            <a href={href} className="nav-link link-body-emphasis dark-blue" onClick={(e) => { e.preventDefault(); window.open("https://ind01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fdrive.google.com%2Ffile%2Fd%2F15ZH6d4c1xG_UVF_7vPVoacnUhwoL_bos%2Fview&data=05%7C02%7Crajatkishore%40chola.murugappa.com%7C217abb061ba0490c02e108dee3075b80%7C370ba3da1a7a440ea7a7b857f46e8f6e%7C1%7C0%7C639197817892108845%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=Ny%2BKSQvosGzEKXtqtwJJ7Uu5xAG1Jvt18LM1SeEsRXg%3D&reserved=0", "_blank", "noopener,noreferrer"); }}>
                                                Screenbros app
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="profile-bottom">
                                        <div className="row gy-4 p-1">

                                            <div className="col-md-12 ">
                                                <div className="d-flex align-items-center gap-2">
                                                    <ImageComponent fileName="gender-icon.svg" alt="profile" />
                                                    <div>
                                                        <p className="fw-medium mb-0">{userName}</p>
                                                        <span className="text-secondary fw-normal small sidebar-email"
                                                        >{emailID}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <button className="text-decoration-none text-black bg-white border-0 p-0 d-flex gap-4 align-items-center" onClick={(e) => {
                                                    e.preventDefault();
                                                    handleLogout();
                                                }}>
                                                    <i className="icon-arrowlogout-E1 fs-4 dark-blue"></i>

                                                    Logout
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </div>
    )
}

export default Headers